import { useNavigate } from 'react-router-dom';

/**
 * Compact Dashboard teaser for Batch Checker.
 * No live earnings data — just a CTA. Keeps the Dashboard light.
 */
export default function BatchCheckerPanel() {
  const navigate = useNavigate();
  return (
    <div
      className="bg-zinc-900 border border-zinc-800 rounded-lg p-5 mb-6"
      data-testid="batch-checker-panel"
    >
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="flex items-center gap-2">
            <span className="text-xl">📦</span>
            <h3 className="text-lg font-bold text-white">Batch Price Checker</h3>
            <span
              className="text-[10px] font-black px-2 py-0.5 rounded-full"
              style={{ background: '#00D26A', color: '#050505' }}
            >
              NEW
            </span>
          </div>
          <p className="text-sm text-zinc-400 mt-1">
            Check 100–250 barcodes in one go. Earn up to <strong className="text-[#FFD700]">£12.50</strong> per completed batch.
          </p>
        </div>
        <div className="flex gap-2 flex-wrap">
        <button
          onClick={() => navigate('/screenshot-import')}
          className="px-4 py-2 rounded-full font-bold text-sm border border-zinc-700 text-zinc-200 hover:bg-zinc-800"
          data-testid="open-screenshot-import-btn"
        >
          Import basket screenshot
        </button>
        <button
          onClick={() => navigate('/batch')}
          className="px-4 py-2 rounded-full font-bold text-sm"
          style={{ background: 'linear-gradient(90deg,#00D26A,#FFD700)', color: '#050505' }}
          data-testid="open-batch-checker-btn"
        >
          Start a batch →
        </button>
        </div>
      </div>
    </div>
  );
}
